import React, { FC, ReactNode, Ref, RefObject, useMemo } from 'react'
import { ScrollbarProps, Scrollbars } from 'react-custom-scrollbars-2'
import { debounce } from 'lodash'
import ScrollbarsComponent from 'components/base/Scrollbars'
import { VIRTUAL_SCROLL_CONTAINER_CLASS } from 'constant'
import { VirtualScrollCallBack } from 'types/common'
import { FixedSizeList } from 'react-window'
import { Inner, VirtualRowRenderer } from './VirtualRow'
import { DragRef, VirtualRowItemData } from './types'

interface OuterElementProps extends Omit<ScrollbarProps, 'ref'> {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const OuterElement = React.forwardRef<Ref<Scrollbars>, OuterElementProps>((props, ref) => {
  const { children, className, style, ...rest } = props

  return (
    <ScrollbarsComponent
      ref={node => {
        if (node?.container) {
          if (typeof ref === 'function') {
            ref(node.container)
          } else if (ref) {
            // eslint-disable-next-line no-param-reassign
            ref.current = node
          }
        }
      }}
      renderViewClassName="media-scrollbar"
      className={`${className || ''} ${VIRTUAL_SCROLL_CONTAINER_CLASS}`}
      style={{ ...style }}
      viewStyle={{ overflowY: 'auto', overflowX: 'auto' }}
      {...rest}
    >
      {children}
    </ScrollbarsComponent>
  )
})

interface VirtualListProps {
  rowCount: number,
  itemSize: number,
  itemData: VirtualRowItemData,
  onScroll: VirtualScrollCallBack
  assetListHeightRef: RefObject<number>
  height: number
  drag: DragRef,
}

export const VirtualList: FC<VirtualListProps> = props => {
  const { rowCount, itemSize, itemData, height, onScroll, drag } = props
  const debouncedScroll = useMemo(() => debounce(onScroll, 50), [ onScroll ])

  return (
    <FixedSizeList
      height={height}
      width="100%"
      itemCount={rowCount}
      itemSize={itemSize}
      itemData={itemData}
      innerElementType={Inner}
      outerElementType={OuterElement}
      /* eslint-disable @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      outerRef={drag}
      onScroll={debouncedScroll}
    >
      {VirtualRowRenderer}
    </FixedSizeList>
  )
}
